export default __webpack_public_path__ + "files/82b8e1265bd8ed477e0d8a05e3b6141c.jpg";